import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';

import '../assets/css/Bubble.scss';

const Bubble = ({ condition, text }) => {  
  return (
    <div
      className="circle-box mx-0">
      <div className={'circle-' + (condition ? 'red' : 'black')}>
        {condition ? (
          <FontAwesomeIcon icon={faCheck} className="p-circle-check" />
        ) : (
          <FontAwesomeIcon icon={faTimes} className="p-circle-times" />
        )}
      </div>
      <p style={{ marginTop: '10px' }}>{text}</p>
    </div>
  );
};

export default Bubble;
